<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
        <template slot="bodyForm">
            <CLoader :pConfigLoad="ConfigLoad">
                <template slot="BodyFormLoad">
                    <div class="container-fluid">
                        <form id="FormConfiSseguimiento" role="form" method="post" autocomplete="off"
                            onSubmit="return false">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <label class="form-label" for="Folio">Folio Cotización</label>
                                            <input readonly type="text" :value="Cotizacion.Folio" class="form-control"
                                                id="Folio" placeholder="Ingresar folio cotización" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <label class="form-label" for="configSeguimiento">Configuración de
                                                seguimiento</label>
                                            <input readonly type="text" :value="ConfigSeguimiento.NombrePeriodo" class="form-control"
                                                id="configSeguimiento" placeholder="Ingresar Configuración seguimiento" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <label class="form-label" for="ejecutivo">Ejecutivo asignado</label>
                                            <input readonly type="text" :value="Ejecutivo.NombreCompleto" class="form-control"
                                                id="ejecutivo" placeholder="Ingresar ejecutivo" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <label class="form-label" for="fechaI">Fecha Inicio</label>
                                            <input readonly type="text" :value="FechaInicio" class="form-control"
                                                id="fechaI" placeholder="Ingresar fecha inicio" />
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <label class="form-label" for="fechaF">Fecha Fin</label>
                                            <input readonly type="text" :value="FechaFin" class="form-control"
                                                id="fechaF" placeholder="Ingresar fecha fin" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9">
                                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                                data-bs-target="#home-tab-pane" type="button" role="tab"
                                                aria-controls="home-tab-pane" aria-selected="true">Etapa 1</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                                data-bs-target="#profile-tab-pane" type="button" role="tab"
                                                aria-controls="profile-tab-pane" aria-selected="false">Etapa 2</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="contact-tab" data-bs-toggle="tab"
                                                data-bs-target="#contact-tab-pane" type="button" role="tab"
                                                aria-controls="contact-tab-pane" aria-selected="false">Etapa 3</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="disabled-tab" data-bs-toggle="tab"
                                                data-bs-target="#disabled-tab-pane" type="button" role="tab"
                                                aria-controls="disabled-tab-pane" aria-selected="false">Etapa 4</button>
                                        </li>
                                    </ul>
                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel"
                                            aria-labelledby="home-tab" tabindex="0">
                                            <h6 class="mt-3">Prospecto</h6>
                                            <div class="form-group row">
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <label class="form-label" for="DiasEtapa1">Días asignados:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[0].DiasAsignados"
                                                                class="form-control" id="DiasEtapa1" />
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaIEtapa1">Fecha Inicio:</label>
                                                            <input readonly 
                                                                type="text" :value="Etapas[0].FechaInicio"
                                                                class="form-control" id="FechaIEtapa1" />
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaFEtapa1">Fecha Fin:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[0].FechaFin"
                                                                class="form-control" id="FechaFEtapa1" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel"
                                            aria-labelledby="profile-tab" tabindex="0">
                                            <h6 class="mt-3">Cotización</h6>
                                            <div class="form-group row">
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <label class="form-label" for="DiasEtapa2">Días asignados:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[1].DiasAsignados"
                                                                class="form-control" id="DiasEtapa2" />
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaIEtapa2">Fecha Inicio:</label>
                                                            <input readonly 
                                                                type="text" :value="Etapas[1].FechaInicio"
                                                                class="form-control" id="FechaIEtapa2" />
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaFEtapa2">Fecha Fin:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[1].FechaFin"
                                                                class="form-control" id="FechaFEtapa2" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                                    <div class="table-responsive">
                                                        <table class="table align-items-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th :class="StyleTh + ' text-center'">#</th>
                                                                    <th :class="StyleTh" width="35%">Nombre</th>
                                                                    <th :class="StyleTh" width="20%">Cant. Mínima</th>
                                                                    <th :class="StyleTh" width="20%">Reliazadas</th>
                                                                    <th :class="StyleTh" width="25%">Estatus</th>
                                                                 </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(detalle, index) in Etapas[1].Detalles"
                                                                    :key="index">
                                                                    <td class="text-center">
                                                                        <p :class="StyleTd">{{ (index + 1) }}</p>
                                                                    </td>
                                                                    <td>
                                                                        <h6 :class="StylePr">{{ detalle.NombreAccion }}
                                                                        </h6>
                                                                    </td>
                                                                    <td><input
                                                                            readonly 
                                                                            type="text" :name="'CantidadAccion' + index"
                                                                            :id="'CantidadAccion' + index"
                                                                            class="form-control"
                                                                            :value="detalle.Cantidad"></td>
                                                                    <td><input
                                                                            readonly 
                                                                            type="text" :name="'CantidadAccion' + index"
                                                                            :id="'CantidadAccion' + index"
                                                                            class="form-control"
                                                                            :value="detalle.Realizadas"></td>
                                                                    <td>
                                                                        <label :class=GetBadgeClass(detalle.Estatus)>{{detalle.Estatus}}</label>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel"
                                            aria-labelledby="contact-tab" tabindex="0">
                                            <h6 class="mt-3">Confirmación cotización</h6>
                                            <div class="form-group row">
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <label class="form-label" for="DiasEtapa3">Días asignados:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[2].DiasAsignados"
                                                                class="form-control" id="DiasEtapa3" />
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaIEtapa3">Fecha Inicio:</label>
                                                            <input readonly 
                                                                type="text" :value="Etapas[2].FechaInicio"
                                                                class="form-control" id="FechaIEtapa3" />
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaFEtapa3">Fecha Fin:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[2].FechaFin"
                                                                class="form-control" id="FechaFEtapa3" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                                    <div class="table-responsive">
                                                        <table class="table align-items-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th :class="StyleTh + ' text-center'">#</th>
                                                                    <th :class="StyleTh" width="35%">Nombre</th>
                                                                    <th :class="StyleTh" width="20%">Cant. Mínima</th>
                                                                    <th :class="StyleTh" width="20%">Reliazadas</th>
                                                                    <th :class="StyleTh" width="25%">Estatus</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(detalle, index) in Etapas[2].Detalles"
                                                                    :key="index">
                                                                    <td class="text-center">
                                                                        <p :class="StyleTd">{{ (index + 1) }}</p>
                                                                    </td>
                                                                    <td>
                                                                        <h6 :class="StylePr">{{ detalle.NombreAccion }}
                                                                        </h6>
                                                                    </td>
                                                                    <td><input
                                                                            readonly 
                                                                            type="text" :name="'CantidadAccion' + index"
                                                                            :id="'CantidadAccion' + index"
                                                                            class="form-control"
                                                                            :value="detalle.Cantidad"></td>
                                                                    <td><input
                                                                            readonly 
                                                                            type="text" :name="'CantidadAccion' + index"
                                                                            :id="'CantidadAccion' + index"
                                                                            class="form-control"
                                                                            :value="detalle.Realizadas"></td>
                                                                    <td>
                                                                        <label class="badge" :class=GetBadgeClass(detalle.Estatus)>{{detalle.Estatus}}</label>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="disabled-tab-pane" role="tabpanel"
                                            aria-labelledby="disabled-tab" tabindex="0">
                                            <h6 class="mt-3">Encuesta y Facturación</h6>
                                            <div class="form-group row">
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <label class="form-label" for="DiasEtapa4">Días asignados:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[3].DiasAsignados"
                                                                class="form-control" id="DiasEtapa4" />
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaIEtapa4">Fecha Inicio:</label>
                                                            <input readonly 
                                                                type="text" :value="Etapas[3].FechaInicio"
                                                                class="form-control" id="FechaIEtapa4" />
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-16">
                                                            <label class="form-label" for="FechaFEtapa4">Fecha Fin:</label>
                                                            <input readonly
                                                                type="text" :value="Etapas[3].FechaFin"
                                                                class="form-control" id="FechaFEtapa4" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>

                        </form>
                    </div>
                </template>
            </CLoader>
        </template>
    </CList>

</template>

<script>
import Configs from '@/helpers/VarConfig.js';

export default {
    name: 'FormConfiSseguimiento',
    props: ['pIdCliente'],
    components: {
    },
    data() {
        return {
            ConfigList: {
                Title: 'Seguimiento Acciones',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                ShowTitleFirst: false,
                TypeBody: 'Form',
                // EmitSeccion: EmitEjecuta,
            },
            ConfigLoad: {
                ShowLoader: true,
                ClassLoad: false,
            },
            ObjAccSeg: {},
            Cotizacion: {
                Folio:'',
            },
            Ejecutivo:{},
            ConfigSeguimiento:{},
            Etapas:[{
                Etapa:'1',
                DiasAsignados:'',
                FechaInicio:'',
                FechaFin:'',
                Detalles:[],
            },
            {
                Etapa:'2',
                DiasAsignados:'',
                FechaInicio:'',
                FechaFin:'',
                Detalles:[],
            },
            {
                Etapa:'3',
                DiasAsignados:'',
                FechaInicio:'',
                FechaFin:'',
                Detalles:[],
            },
            {
                Etapa:'4',
                DiasAsignados:'',
                FechaInicio:'',
                FechaFin:'',
                Detalles:[],
            }],
            FechaInicio:'',
            FechaFin:'',
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'prospectos',
                // EmitSeccion: EmitEjecuta,
            },
            IdCliente:0,
            segurity:{},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            errorvalidacion: [],
        
            //masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods:
    {
        Recuperar() {
            this.$http.get(
                "accionesSeguimiento/" + this.IdCliente
            ).then((res) => {
                this.SetData(res.data.data);
                this.SetAccionesDetalles();
            }).finally(() => {
                this.ConfigLoad.ShowLoader = false;
            }).catch((err)=>{
                if(err.response.data.type == 1){
                    this.$toast.warning('Error: No se encontraron cotizaciones para este prospecto.');
                    this.Regresar();
                } else if (err.response.data.type == 2){
                    this.$toast.info(err.response.data.message);
                    this.SetAccionesDetalles();
                    this.SetData(err.response.data.data);
                }
            });
        },
        GetBadgeClass(estatus){
            return{
                'badge bg-info':estatus=='Pendiente',
                'badge bg-danger':estatus=='No cumplida',
                'badge bg-success':estatus=='Cumplida',
            }
        },
        Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute, params:{}});
        },
        Limpiar() {
            this.errorvalidacion = [];
        },
        // RECUPERA LAS ACCIONES Y LOS DETALLES Y LOS JUNTA DONDE SEA LOS IDACCION COINCIDAN
        SetAccionesDetalles(){
            let EtapasCopia = JSON.parse(JSON.stringify(this.Etapas));
            this.$http.get('acciones'
            ).then((res) => {
                const ACCIONES = res.data.data.data;
                EtapasCopia[1].Detalles = [];
                EtapasCopia[2].Detalles = [];
                ACCIONES.forEach(accion => {
                    let newDetalle = {
                        IdEtapaDetalle:0,
                        IdEtapaSeguimiento:0,
                        NombreAccion:accion.Nombre,
                        Cantidad:'',
                        IdAccion:accion.IdAccion,
                    };

                    // Para Etapa 2 (Cotización)
                    let newDetEtapa2 = {...newDetalle};
                    let detalleEtapa2 = this.Etapas[1].Detalles.find(detalle => detalle.IdAccion == accion.IdAccion);
                    if (detalleEtapa2){
                       Object.assign(newDetEtapa2, detalleEtapa2)
                    } 
                    EtapasCopia[1].Detalles.push(newDetEtapa2);
                    
                    // Para Etapa 3 (Cotización y Confirmación)
                    let newDetEtapa3 = {...newDetalle};
                    let detalleEtapa3 = this.Etapas[2].Detalles.find(detalle => detalle.IdAccion == accion.IdAccion);
                    if (detalleEtapa3){
                        Object.assign(newDetEtapa3, detalleEtapa3);
                    } 
                    EtapasCopia[2].Detalles.push(newDetEtapa3);
                })
            }).finally(()=>{
                this.Etapas = EtapasCopia;
            }).catch(err => console.error(err));
        },
        SetData(resp){
            this.FechaInicio = resp.FechaInicio??'';
            this.FechaFin = resp.FechaFin??'';
            if(resp.Ejecutivo) Object.assign(this.Ejecutivo,resp.Ejecutivo);
            if(resp.Etapas) Object.assign(this.Etapas,resp.Etapas);
            if(resp.Cotizacion) Object.assign(this.Cotizacion,resp.Cotizacion);
            if(resp.ConfigSeguimiento) Object.assign(this.ConfigSeguimiento,resp.ConfigSeguimiento);
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;
        if(this.pIdCliente != undefined){
            sessionStorage.setItem('IdCliente',JSON.stringify(this.pIdCliente));
        }

        this.IdCliente = JSON.parse(sessionStorage.getItem('IdCliente'));
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Limpiar();
        this.Recuperar();
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
